import { ZonedDateTimeFormatter, getTimeZoneId } from '@csp/csp-common-date-util';
import { Maybe, MetricPeriod, ZonedDateTime, ZonedDateTimeStr } from '@csp/csp-common-model';
import { ScheduleRef } from '@csp/csp-common-scheduling';
import { MetricPeriodUtil } from '../util/MetricPeriodUtil';

export type ScheduleRequestMetricCriterion = {
  scheduleRef: ScheduleRef;
  minComplianceThreshold: Maybe<number>;
  recentPeriod: Maybe<MetricPeriod>;
  recentPeriodZonedDateTime: Maybe<ZonedDateTime>;
  recentPeriodZonedDateTimeStr: Maybe<ZonedDateTimeStr>;
  daysPerMonth: number;
};

const from = ({
  scheduleRef,
  daysPerMonth,
  recentPeriod,
  minComplianceThreshold,
}: {
  scheduleRef: ScheduleRef;
  daysPerMonth: number;
  minComplianceThreshold?: number;
  recentPeriod?: MetricPeriod;
}): ScheduleRequestMetricCriterion => {
  const recentPeriodZonedDateTime = recentPeriod
    ? {
        unixTimeMillis: Date.now() - MetricPeriodUtil.periodToMillis(recentPeriod, daysPerMonth),
        zone: getTimeZoneId(),
      }
    : undefined;

  return {
    scheduleRef,
    daysPerMonth,
    recentPeriod,
    minComplianceThreshold,
    recentPeriodZonedDateTime,
    recentPeriodZonedDateTimeStr: ZonedDateTimeFormatter.toZonedDateTimeString(recentPeriodZonedDateTime),
  };
};

export const ScheduleRequestMetricCriterion = {
  from,
};
